import {CookingType} from "./CookingModel";
import {DurianIceCreamActivity} from "./DurianIceCreamActivity";
import {PastaCookingActivity} from "./PastaCookingActivity";
import {TurkishDelightActivity} from "./TurkishDelightActivity";
import {CoconutMilkActivity} from "./CoconutMilkActivity";

export const CookingActivities = {
    [CookingType.Durian]: DurianIceCreamActivity,
    [CookingType.Pasta]: PastaCookingActivity,
    [CookingType.Delight]: TurkishDelightActivity,
    [CookingType.Coconut]: CoconutMilkActivity,
};